<template>
  <v-layout justify-center="" style="margin-top: 10%;">
    <v-card :elevation="20" width="500" v-bind:loading="loading">
      <v-card-text class="text-center">
        <h1 class="font-weight-light">Change Password</h1>
      </v-card-text>
      <v-form ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="password"
                  :type="'password'"
                  name="new-password"
                  label="Password"
                  required
                  outlined
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="confirmPassword"
                  :type="'password'"
                  name="confirm-password"
                  label="Confirm Password"
                  required
                  outlined
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                {{ error }}
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="orange"
            v-on:click="change"
            :disabled="!password"
            x-large
            v-bind:loading="loading"
            >Change Password
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-form>
      <v-card-text>
        <a v-on:click="signIn">Back to Sign In</a>
      </v-card-text>
    </v-card>
  </v-layout>
</template>
<script>
import AuthEventBus from '../events/authEventBus'
import { Auth } from 'aws-amplify'

export default {
  name: 'RequireNewPassword',
  props: ['requireNewPasswordConfig'],
  data() {
    return {
      user: '',
      error: '',
      password: '',
      confirmPassword: '',
      loading: false
    }
  },
  computed: {
    options() {
      const defaults = {
        user: null
      }
      return Object.assign(defaults, this.requireNewPasswordConfig || {})
    }
  },
  methods: {
    setError: function(e) {
      this.error = e.message
    },
    checkContact(user) {
      Auth.verifiedContact(user)
        .then(data => {
          AuthEventBus.$emit('localUser', this.user)
          AuthEventBus.$emit('authState', 'signedIn')
        })
        .catch(e => this.setError(e))
    },
    change() {
      if (this.password !== this.confirmPassword) {
        this.error = 'Passwords do not match!'
        return
      }
      this.loading = true
      Auth.completeNewPassword(
        this.options.user,
        this.password,
        this.requiredAttributes
      )
        .then(user => {
          if (this.options.user.challengeName === 'SMS_MFA') {
            AuthEventBus.$emit('localUser', this.options.user)
            AuthEventBus.$emit('authState', 'confirmSignIn')
          } else if (this.options.user.challengeName === 'MFA_SETUP') {
            AuthEventBus.$emit('localUser', this.options.user)
            AuthEventBus.$emit('authState', 'setMfa')
          } else {
            this.checkContact(this.options.user)
          }
        })
        .catch(err => this.setError(err))
    },
    signIn: function() {
      AuthEventBus.$emit('authState', 'signIn')
    }
  }
}
</script>
